export enum DepartmentTypesId {
  school = 1, // Школа
  university = 2, // ВУЗ
  jurisdiction = 3, // Подведомство
}
